// extracted by mini-css-extract-plugin
module.exports = {"container":"EphemeralReactions_container__31DUj"};